"use client";

import {
  CheckCircleIcon,
  ExclamationTriangleIcon,
  InformationCircleIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import { Loader2Icon, OctagonAlertIcon } from "lucide-react";
import { useTheme } from "next-themes";
import { Toaster as Sonner, ToasterProps } from "sonner";

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className='toaster group'
      icons={{
        success: <CheckCircleIcon className='size-9.5' />,
        error: <OctagonAlertIcon className='size-9.5' />,
        warning: <ExclamationTriangleIcon className='size-9.5' />,
        info: <InformationCircleIcon className='size-9.5' />,
        close: (
          <div className='bg-sonner-normal-description-text flex size-5 items-center justify-center rounded-full'>
            <XMarkIcon className='size-3 stroke-4 text-white' />
          </div>
        ),
        loading: <Loader2Icon className='size-7.5 animate-spin' />,
      }}
      toastOptions={{
        style: {
          border: "none",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
          borderRadius: "10px",
        },
        classNames: {
          toast: "!relative shadow-lg border-0 flex items-center !gap-5 !h-15",
          title: "!py-0 !my-0 !leading-none !text-base !font-semibold",
          closeButton: "!p-0 !size-5 !border-0",
          actionButton:
            "!bg-btn-primary !text-text-title-inv !px-3 !py-4 !rounded-lg !text-xs !font-semibold hover:!opacity-90 !transition-opacity",
          description: "!text-sonner-normal-description-text !py-0 !my-0 !leading-none !text-xs",
          content: "!flex-1 !gap-1 !space-y-0 !flex !flex-col",
          icon: "",
        },
      }}
      style={
        {
          "--normal-bg": "var(--sonner-normal-bg)",
          "--normal-text": "var(--sonner-normal-text)",
          "--normal-border": "var(--sonner-normal-border)",
          "--normal-description-text": "var(--sonner-normal-description-text)",
          "--success-bg": "var(--sonner-success-bg)",
          "--success-text": "var(--sonner-success-text)",
          "--success-border": "var(--sonner-success-border)",
          "--success-description-text": "var(--sonner-success-description-text)",
          "--error-bg": "var(--sonner-error-bg)",
          "--error-text": "var(--sonner-error-text)",
          "--error-border": "var(--sonner-error-border)",
          "--error-description-text": "var(--sonner-error-description-text)",
          "--warning-bg": "var(--sonner-warning-bg)",
          "--warning-text": "var(--sonner-warning-text)",
          "--warning-border": "var(--sonner-warning-border)",
          "--warning-description-text": "var(--sonner-warning-description-text)",
          "--info-bg": "var(--sonner-info-bg)",
          "--info-text": "var(--sonner-info-text)",
          "--info-border": "var(--sonner-info-border)",
          "--info-description-text": "var(--sonner-info-description-text)",
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
